import React from 'react';
const Friends = ({ setCurrentPage, referralCode, triggerToast }) => {
    const shareReferralLink = () => {
        const telegramUrl = `https://t.me/share/url?url=${referralCode}&text=🎉 Присоединяйся через мою реферальную ссылку и получи 20,000 на стартовый баланс! 🚀💰`;
        window.open(telegramUrl, '_blank');
      };
      const copyText = () => {
        const textToCopy = referralCode; 
        triggerToast("Скопировано!");
        navigator.clipboard.writeText(textToCopy);
      }
  return (
    <div className='container_'>
        <h1>Пригласите друзей!</h1>
        <div className='friends_footer'>
            <div className='invite_btn' onClick={shareReferralLink}>Поделиться!</div>
            <div className='copy' onClick={copyText}>
                <img src='/assets/imgur/A8tbZyv.png' alt=''></img>
            </div>
        </div>
        <h1>Приглашай друзей и получай бонусы!</h1>
        <div className='Big_Reklama'>
            <div className='block_rekl'>            
                <div className='info_row_sub_sika'>
                    <img src='/assets/currency-coin-v2.png' alt=''></img>
                    <span>+20.000</span>
                </div>
                За каждого друга и <span>1%</span> к силе клика
            </div>
            <div className='block_rekl_id'><h4 style={{ marginTop: '10px' }}>За каждые <span>10</span> приглашённых игроков вы получите награду</h4>
            <button className='btn_firends' onClick={() => setCurrentPage('friends_sub')}>Посмотреть</button></div>
            
        </div>
        <h1>Бонусы за прогресс друзей!</h1>
        <div className='Medium_Reklama'>
            <div className='Med_block'>            <div className='info_row_sub_sika'>
                <img src='/assets/currency-coin-v2.png' alt=''></img>
                <span>+20.000</span>
            </div>За достижение бронзовой лиги</div>
            <div className='Med_block'>            <div className='info_row_sub_sika'>
                <img src='/assets/currency-coin-v2.png' alt=''></img>
                <span>+20.000</span>
            </div>За достижение алмазной лиги</div>
            <div className='Med_block'>           
                 <div className='info_row_sub_sika'>
                <img src='/assets/currency-coin-v2.png' alt=''></img>
                <span>+20.000</span>
            </div> За достижение ВИП лиги</div>
        </div>
        <div style={{ height: '40px' }}></div> 
    </div>
  );
}

export default Friends;
